/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordRenewalInProgress
 */
export interface PasswordRenewalInProgress {
    /**
     * The email of the account subject to password renewal
     * @type {string}
     * @memberof PasswordRenewalInProgress
     */
    email: string;
}

/**
 * Check if a given object implements the PasswordRenewalInProgress interface.
 */
export function instanceOfPasswordRenewalInProgress(value: object): value is PasswordRenewalInProgress {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function PasswordRenewalInProgressFromJSON(json: any): PasswordRenewalInProgress {
    return PasswordRenewalInProgressFromJSONTyped(json, false);
}

export function PasswordRenewalInProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordRenewalInProgress {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function PasswordRenewalInProgressToJSON(value?: PasswordRenewalInProgress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
    };
}

